import { OverlayModule } from '@angular/cdk/overlay';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { CommonModule, DecimalPipe } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { CUSTOM_ELEMENTS_SCHEMA, ErrorHandler, NgModule } from '@angular/core';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { MatInputModule } from '@angular/material/input';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTableModule } from '@angular/material/table';
import { RouterModule } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { CheckboxComponent } from '@shared/components/checkbox/checkbox.component';
import {
  ChecklistTableColumnDefDirective,
  ChecklistTableComponent
} from '@shared/components/checklist-table/checklist-table.component';
import { HereMapModule } from '@shared/components/here-map/here-map.module';
import { LoaderComponent } from '@shared/components/loader/loader.component';
import { LocalizedDatePipe } from '@shared/pipes/localized-date/localized-date.pipe';
import { ServiceEventHeaderJobPipe } from '@shared/pipes/service-event/service-event.pipe';
import { InformationComponent } from '@teamsp/components';
import { ButtonModule } from '@teamsp/components/button';
import { LOADER_COMPONENT_TOKEN, LoaderModule } from '@teamsp/components/loader';
import { GlobalErrorHandler } from './errors/error-handler';
import { BookingProposalPlaygroundInterceptor } from './http-interceptors/booking-proposal-playground-interceptor';
import { TegelModule } from '@scania/tegel-angular-17';

@NgModule({
  declarations: [CheckboxComponent, ChecklistTableColumnDefDirective, ChecklistTableComponent, LoaderComponent],
  imports: [
    ButtonModule,
    CommonModule,
    HereMapModule,
    InformationComponent,
    LoaderModule,
    LocalizedDatePipe,
    MatInputModule,
    MatPaginatorModule,
    MatProgressSpinnerModule,
    MatTableModule,
    OverlayModule,
    RouterModule,
    ScrollingModule,
    ServiceEventHeaderJobPipe,
    TegelModule,
    TranslateModule
  ],
  providers: [
    { provide: ErrorHandler, useClass: GlobalErrorHandler },
    { provide: HTTP_INTERCEPTORS, useClass: BookingProposalPlaygroundInterceptor, multi: true },
    { provide: LOADER_COMPONENT_TOKEN, useValue: LoaderComponent },
    { provide: MAT_DATE_LOCALE, useValue: 'en-GB' },
    DecimalPipe,
    TranslateService
  ],
  exports: [
    ButtonModule,
    CheckboxComponent,
    ChecklistTableColumnDefDirective,
    ChecklistTableComponent,
    HereMapModule,
    InformationComponent,
    LoaderComponent,
    LoaderModule,
    LocalizedDatePipe,
    ServiceEventHeaderJobPipe,
    TranslateModule
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class SharedModule {}
